<script>
  import * as scorePresets       from '../../../services/score-presets';
  import {bodyTypeFlagsStore}    from '../../../stores/filters/body-type-flags-store';
  import {driverSizeFlagsStore}  from '../../../stores/filters/driver-size-flags-store';
  import {driverStore}           from '../../../stores/filters/driver-store';
  import {scoresStore}           from '../../../stores/filters/scores-store';
  import {helpStore}             from '../../../stores/help-store';
  import {results1BuiltStore}    from '../../../stores/results/results-1-built-store';
  import {results2FilteredStore} from '../../../stores/results/results-2-filtered-store';
  import HelpButton              from '../../help-button/help-button.svelte';

  const helps = {
    balanced: {
      topic: 'Balanced vehicle',
      description: 'This well-rounded vehicle has no significant weaknesses.'
    },
    beginner: {
      topic: 'Beginner vehicle',
      description: 'A beginner needs Acceleration to recover from driving off-road or being attacked, and Handling to take sharp turns before learning to drift.'
    },
    boostFocused: {
      topic: 'Boost-focused vehicle',
      description: 'Experienced racers who frequently use drift boosts might prioritize Mini-Turbo.'
    },
    handicap: {
      topic: 'Handicap vehicle',
      description: "If victory comes too easily and you need an extra challenge, try winning with this vehicle that's low on both Speed and Acceleration."
    },
    speedFocused: {
      topic: 'Speed-focused vehicle',
      description: 'Experienced racers who are able to stay on the road, avoid obstacles, and defend themselves against attacks might prioritize Speed.'
    },
    tractionFocused: {
      topic: 'Traction-focused vehicle',
      description: 'If you have trouble on slippery tracks (ice/sand), this vehicle should help make your ride more consistent.'
    }
  };

  const showHelp = (help) => {
    helpStore.change(help);
    window.scrollTo(0, 0);
  };

  const onShowBalanced = (evt) => {
    updateHelpAndFilters(helps.balanced, scorePresets.balancedScores());
  };

  const onShowBeginner = () => {
    updateHelpAndFilters(helps.beginner, scorePresets.beginnerScores());
  };

  const onShowBoostFocused = () => {
    updateHelpAndFilters(helps.boostFocused, scorePresets.boostFocusedScores());
  };

  const onShowHandicap = () => {
    updateHelpAndFilters(helps.handicap, scorePresets.handicapScores());
  };

  const onShowSpeedFocused = () => {
    updateHelpAndFilters(helps.speedFocused, scorePresets.speedFocusedScores());
  };

  const onShowTractionFocused = () => {
    updateHelpAndFilters(helps.tractionFocused, scorePresets.tractionFocusedScores());
  };

  const updateHelpAndFilters = (help, scores) => {
    results1BuiltStore.freeze();
    results2FilteredStore.freeze();

    showHelp(help);
    driverSizeFlagsStore.reset();
    driverStore.set(null);
    bodyTypeFlagsStore.reset();
    scoresStore.set(scores);

    results1BuiltStore.unfreeze();
    results2FilteredStore.unfreeze();
    results1BuiltStore.refresh();
  };
</script>

<style>
  #quick-picks-list {
    list-style-type: none;
    margin-left: -40px;
  }

  .quick-pick {
    border: 1px solid darkgray;
    border-radius: 10px;
    cursor: pointer;
    display: inline-block;
    margin-right: 20px;
    padding: 10px;
  }

  .quick-pick img {
    margin-top: 5px;
  }
</style>

<template lang="pug" src="./quick-picks.pug"></template>
